import { Box, Modal, Typography } from '@mui/material'
import React from 'react'

export default function ApplyModal({closemodal, openmodal}) {


    return (
        <>
            <Modal
                open={openmodal}
                onClose={closemodal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Text in a modal
                    </Typography>
                    <Typography id="modal-modal-description">
                        Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                    </Typography>
                </Box>
            </Modal>

        </>


    )

}